import angular from "angular";

class DispatchCtrl {
    constructor() {
        this.checkedOrders = {};
        this.duplicatedInfo = "Duplicates are only temporary. They will automatically disappear if you didn't assign any Hauler or Applicator and left the page."
    }

    isOpen(ticket) {
        return ["mixed", "ready_to_bill", "pending"].includes(ticket.status)
    }

    validateCheckedOrders(unlink=false) {
        let self = this
        let valid = true
        let applicator = Object.keys(self.checkedOrders)[0].split("/")[1]
        if (!applicator) {
            self.$growl.error("Cannot link not assigned orders!")
            return false
        }
        if (Object.keys(self.checkedOrders).length < 2 && !unlink) {
            self.$growl.error("You have to choose at least 2 orders!")
            return false
        }
        Object.keys(self.checkedOrders).forEach(checkedOrderName => {
            if (checkedOrderName.split("/")[1] != applicator) {
                self.$growl.error("Cannot link orders from different Applicators/Haulers!")
                valid = false
            }
        })
        return valid
    }

    getCheckedObjectsAndLinked(checkedOrders) {
        let self = this
        let checkedObjectsLinked = []

        // TODO: optimize if possible
        Object.keys(checkedOrders).forEach(checkedOrderName => {
            let [checkedOrderId, applicatorId] = checkedOrderName.split("/")
            if (applicatorId) {
                let orderObject = self.orderFromApplicatorHauler(checkedOrderId, applicatorId)
                checkedObjectsLinked = checkedObjectsLinked.concat(orderObject.linked_with["linked"], checkedOrderName)
            }
        })

        let linkedWithoutDuplicates = [...new Set([...checkedObjectsLinked])]
        return linkedWithoutDuplicates
    }

    updateOrderLinked(order_id, applicator_id, checkedOrdersObjectsLinked, unlink=false) {
        let self = this
        self.orderStore.get(order_id).then(order => {
            switch (self.target) {
                case "Applicator":
                    let orderApplicatorIndex = order.applicators.findIndex(a=> a.applicator.id == applicator_id)
                    order.applicators[orderApplicatorIndex].linked_with["linked"] = checkedOrdersObjectsLinked
                    break
                case "Hauler":
                    let orderHaulerIndex = order.haulers.findIndex(a=> a.hauler.id == applicator_id)
                    order.haulers[orderHaulerIndex].linked_with["linked"] = checkedOrdersObjectsLinked
                    break
            }
            order.put().then(
                () => {
                    if (!unlink) {
                        self.$growl.success(
                            `${checkedOrdersObjectsLinked.map(l => l.split("/")[0])} linked together`
                        )
                    }
                },
            )
        })
    }

    unlinkSingleOrder(checkedOrderId, applicator_id) {
        let self = this
        self.orderStore.get(checkedOrderId).then(order => {
            switch (self.target) {
                case "Applicator":
                    let orderApplicatorIndex = order.applicators.findIndex(a=> a.applicator.id == applicator_id)
                    order.applicators[orderApplicatorIndex].linked_with["linked"] = []
                    break
                case "Hauler":
                    let orderHaulerIndex = order.haulers.findIndex(a=> a.hauler.id == applicator_id)
                    order.haulers[orderHaulerIndex].linked_with["linked"] = []
                    break
            }
            order.put()
        })
    }

    linkOrders() {
        let self = this
        let valid = self.validateCheckedOrders()
        if (valid) {
            let checkedOrdersObjectsLinked = self.getCheckedObjectsAndLinked(self.checkedOrders)
            checkedOrdersObjectsLinked.forEach(checkedLinkedName => {
                let [checkedOrderId, applicatorId] = checkedLinkedName.split("/")
                let orderObject = self.orderFromApplicatorHauler(checkedOrderId, applicatorId)
                orderObject.linked_with["linked"] = checkedOrdersObjectsLinked
                self.checkedOrders[checkedLinkedName] = false
            })
            if (checkedOrdersObjectsLinked.length > 1) {
                let [order_id, applicator_id] = checkedOrdersObjectsLinked[0].split("/")
                self.updateOrderLinked(order_id, applicator_id, checkedOrdersObjectsLinked)
            }
            self.prepareLinkedOrders()
        }
    }

    unlinkSelectedOrders(checkedOrders) {
        let self = this
        let checkedOrdersObjectsLinked = self.getCheckedObjectsAndLinked(checkedOrders)
        let unlinkedOrders = checkedOrdersObjectsLinked.filter(l => !Object.keys(checkedOrders).includes(l))

        checkedOrdersObjectsLinked.forEach(checkedLinkedName => {
            let [checkedOrderId, applicatorId] = checkedLinkedName.split("/")
            if (applicatorId) {
                let orderObject = self.orderFromApplicatorHauler(checkedOrderId, applicatorId)
                if (unlinkedOrders.includes(checkedLinkedName)) {
                    orderObject.linked_with["linked"] = unlinkedOrders
                } else if (Object.keys(checkedOrders).includes(checkedLinkedName)){
                    orderObject.linked_with["linked"] = []
                    checkedOrders[checkedLinkedName] = false
                    self.unlinkSingleOrder(checkedOrderId, applicatorId)
                }
            }
        })

        if (unlinkedOrders.length > 0){
            let [order_id, applicator_id] = unlinkedOrders[0].split("/")
            self.updateOrderLinked(order_id, applicator_id, unlinkedOrders, true)
        }
        // show unlink message
        if (unlinkedOrders.length > 0 || Object.keys(checkedOrders).length > 1) {
            self.$growl.success(`${Object.keys(checkedOrders).map(l => l.split("/")[0])} unlinked`)
        }
    }

    unlinkOrders() {
        let self = this
        let valid = self.validateCheckedOrders(true)
        if (valid) {
            self.unlinkSelectedOrders(self.checkedOrders)
            self.prepareLinkedOrders()
        }
    }

    orderHasApplicator(order) {
        if (order.applicators && order.applicators.length > 0) return true
        return false
    }

    orderHasHauler(order) {
        if (order.haulers && order.haulers.length > 0) return true
        return false
    }

    duplicateOrders() {
        let self = this
        Object.keys(self.checkedOrders).forEach(checkedOrderName => {
            // try from orderStore
            let [checkedOrderId, applicatorId] = checkedOrderName.split("/")
            const orderIndex = self.orderStore.list.findIndex(o => o.id == checkedOrderId)
            let checkedOrder = self.orderStore.list[orderIndex]
            if (!checkedOrder) {
                // if not search in applicator_orders
                checkedOrder = self.orderFromApplicatorHauler(checkedOrderId, applicatorId)
                self.orderStore.get(checkedOrder.order.id).then(checkedOrder => {
                    self.checkedOrders[checkedOrderName] = false
                    checkedOrder.duplicate = true
                    self.orderStore.list.unshift(checkedOrder)
                    self.$growl.success(`${checkedOrder.order_id} - duplicate created.`)
                })
            } else {
                checkedOrder = JSON.parse(JSON.stringify(self.orderStore.list[orderIndex]))
                self.checkedOrders[checkedOrderName] = false
                checkedOrder.duplicate = true
                self.orderStore.list.unshift(checkedOrder)
                self.$growl.success(`${checkedOrder.order_id} - duplicate created.`)
            }
        })
    }

    orderFromApplicatorHauler(checkedOrderId, applicatorId) {
        let self = this
        let checkedOrder = null
        let applicatorIndex = self.haulerApplicatorStore.list.findIndex(a => a.id == applicatorId)
        let appHaul = self.haulerApplicatorStore.list[applicatorIndex]
        switch (this.target) {
            case "Applicator":
                appHaul.applicator_orders.forEach(o => {
                    if (o.order.id == checkedOrderId) checkedOrder = o
                })
                break
            case "Hauler":
                appHaul.hauler_orders.forEach(o => {
                    if (o.order.id == checkedOrderId) checkedOrder = o
                })
                break
        }
        return checkedOrder
    }

    updateCheckedOrders() {
        let self = this
        let filteredOrders = Object.keys(self.checkedOrders).reduce((filtered, order) => {
            if (self.checkedOrders[order]) filtered[order] = self.checkedOrders[order];
            return filtered
        }, {})
        self.checkedOrders = filteredOrders
        self.showButtonsIfIsAnyChecked()
    }

    showButtonsIfIsAnyChecked() {
        let buttonsDiv = angular.element(document.getElementById("selected-orders-action"))
        if (Object.keys(this.checkedOrders).length > 0) {
            buttonsDiv.show()
        } else {
            buttonsDiv.hide()
        }
    }

    onMoved(index) {
        this.orderStore.list.splice(index, 1)
    }

    onDrop (event, index, item) {
        let self = this
        let selectedHaulerApplicator = self.haulerApplicatorStore.list[index]
        selectedHaulerApplicator.noEvents = true

        const orderIndex = self.orderStore.list.findIndex(o => o.order_id == item.order_id)
        let grabbedOrder = self.orderStore.restangularize(self.orderStore.list[orderIndex])
        grabbedOrder.noEvents = true

        self.orderStore.get(grabbedOrder.id).then(updatedOrder => {
            switch (this.target) {
                case "Applicator":
                    updatedOrder.applicators.push({
                        "applicator": selectedHaulerApplicator
                    })
                    break
                case "Hauler":
                    updatedOrder.haulers.push({
                        "hauler": selectedHaulerApplicator
                    })
                    break
            }
            return updatedOrder
        }).then(updatedOrder => {
            updatedOrder.put().then(
                () => {
                    // update orders list
                    self.orderStore.list.splice(orderIndex, 1)

                    // avoid Converting circular structure
                    updatedOrder.applicators = updatedOrder.applicators.map(a => a.applicator.id)
                    updatedOrder.haulers = updatedOrder.haulers.map(h => h.hauler.id)

                    switch (self.target) {
                        case "Applicator":
                            updatedOrder.tickets = self.filterApplicatorOrdersTickets(updatedOrder.tickets, selectedHaulerApplicator.id)
                            selectedHaulerApplicator.applicator_orders.push({"order": updatedOrder, "linked_with": {"linked": []}})
                            break
                        case "Hauler":
                            updatedOrder.tickets = self.filterHaulerOrdersTickets(updatedOrder.tickets, selectedHaulerApplicator.id)
                            selectedHaulerApplicator.hauler_orders.push({"order": updatedOrder, "linked_with": {"linked": []}})
                            break
                    }
                    self.$growl.success(`${item.order_id} assigned to ${selectedHaulerApplicator.name}`)
                    grabbedOrder.noEvents = false
                    selectedHaulerApplicator.noEvents = false
                },
                (resp) => {
                    // Order error handling
                    Object.entries(resp.data).forEach(entry => {
                        const [field, error] = entry
                        error.forEach(err_msg => {
                            if (typeof err_msg === 'object' && err_msg !== null) {
                                Object.entries(err_msg).forEach(list_entry => {
                                    self.$growl.error(`${field}: ${list_entry}`)
                                })
                            } else {
                                self.$growl.error(`${field}: ${err_msg}`)
                            }
                        })
                    })
                    self.unassignHaulerApplicator(updatedOrder)
                    grabbedOrder.noEvents = false
                    selectedHaulerApplicator.noEvents = false
                },
            )
        })
    }

    unassignHaulerApplicator(order, haulerApplicatorId) {
        switch (this.target) {
            case "Applicator":
                const appIndex = order.applicators.findIndex(a => a.applicator.id == haulerApplicatorId)
                order.applicators.splice(appIndex, 1)
                break
            case "Hauler":
                const haulIndex = order.haulers.findIndex(a => a.hauler.id == haulerApplicatorId)
                order.haulers.splice(haulIndex, 1)
                break
        }
    }

    removeOrderFromHaulerApplicator(haulerApplicator, orderIndex) {
        switch (this.target) {
            case "Applicator":
                haulerApplicator.applicator_orders.splice(orderIndex, 1)
                break
            case "Hauler":
                haulerApplicator.hauler_orders.splice(orderIndex, 1)
                break
        }
    }

    unassignOrder(order, haulerApplicatorIndex, orderIndex) {
        let self = this
        let haulerApplicator = self.haulerApplicatorStore.list[haulerApplicatorIndex]
        haulerApplicator.noEvents = true

        // unlink orders and then unassign
        let checkedOrders = {}
        checkedOrders[`${order.id}/${haulerApplicator.id}`] = true
        self.unlinkSelectedOrders(checkedOrders)

        self.orderStore.get(order.id).then(cancelledOrder => {
            self.unassignHaulerApplicator(cancelledOrder, haulerApplicator.id)
            cancelledOrder.put().then(
                () => {
                    cancelledOrder.tickets = cancelledOrder.tickets.filter(self.isOpen)
                    if (Object.keys(self.checkedOrders).includes(cancelledOrder.order_id)) {
                        cancelledOrder.duplicate = true
                    }
                    self.orderStore.list.unshift(cancelledOrder)
                    self.removeOrderFromHaulerApplicator(haulerApplicator, orderIndex)
                    self.$growl.success(`${order.id} unassigned.`)
                    haulerApplicator.noEvents = false
                    self.prepareLinkedOrders()
                },
                (resp) => {
                    console.log(resp)
                    haulerApplicator.noEvents = false
                }
            )
        })
    }
}

export class ApplicatorCtrl extends DispatchCtrl{
    constructor($growl, DispatchStore, OrderStore) {
        "ngInject"
        super()
        this.$growl = $growl
        this.haulerApplicatorStore = DispatchStore
        this.orderStore = OrderStore
        this.target = "Applicator"

        this.haulerApplicatorStore.params = {
            page: 1,
            page_size: 15,
        }
        let self = this
        this.haulerApplicatorStore.refresh().then(() => {
            self.prepareApplicatorTickets()
            self.prepareLinkedOrders()
        })
        this.orderStore.params = {
            page: 1,
            status: "dispatcher_filters",
            applicators: "None",
            delivery: ["apply_haul"],
            ticket_status: "open",
        }
        this.orderStore.refresh()
    }

    searchApplicator() {
        let self = this
        this.haulerApplicatorStore.params.page = null
        this.haulerApplicatorStore.refresh().then(() => {
            self.prepareApplicatorTickets()
            self.prepareLinkedOrders()
        })
        this.haulerApplicatorStore.params.page = 1
    }

    prepareApplicatorTickets() {
        // Return only applicator_order tickets assign to picked Applicator.
        let self = this
        self.haulerApplicatorStore.list.forEach(applicator => {
            applicator.applicator_orders.forEach(order => {
                order.order.tickets = self.filterApplicatorOrdersTickets(order.order.tickets, applicator.id)
            })
        })
    }

    filterApplicatorOrdersTickets(tickets, applicator_id) {
        let filteredTickets = []
        tickets.forEach(ticket => {
            if (["mixed", "ready_to_bill", "pending"].includes(ticket.status)) {
                if (ticket.applicators.some(v => v.applicator == applicator_id)) {
                    filteredTickets.push(ticket)
                }
            }
        })
        return filteredTickets
    }

    loadMoreApplicators() {
        let self = this
        self.haulerApplicatorStore.loadMore().then(() => {
            self.prepareApplicatorTickets()
            self.prepareLinkedOrders()
        })
    }

    prepareLinkedOrders() {
        // display linked items under oder without duplicates
        let self = this
        self.haulerApplicatorStore.list.forEach(app => {
            let linkedOrders = []
            app.applicator_orders.map(order => order.linked = false)
            app.applicator_orders.forEach(order => {
                if (!linkedOrders.some(l => l.order.id == order.order.id)) {
                    linkedOrders.push(JSON.parse(JSON.stringify(order)))
                    // iterate through this applicator linked orders
                    let applicator_linked = order.linked_with.linked.filter(l => l.split("/")[0] != order.order.id && l.split("/")[1] == app.id)
                    applicator_linked.forEach(linked_name => {
                        let order_id = linked_name.split("/")[0]
                        let linkedIndex = app.applicator_orders.findIndex(o => o.order.id == order_id)
                        let linkedItem = app.applicator_orders[linkedIndex]

                        linkedOrders[linkedOrders.length-1].linked = true
                        linkedOrders.push(JSON.parse(JSON.stringify(linkedItem)))
                    })
                }
            })
            app.applicator_orders = linkedOrders
        })
    }
}

export class HaulerCtrl extends DispatchCtrl{
    constructor($growl, OrderStore, DispatchStore) {
        "ngInject"
        super()
        this.target = "Hauler"
        this.$growl = $growl
        this.haulerApplicatorStore = DispatchStore
        this.orderStore = OrderStore
        this.haulerApplicatorStore.params = {
            page: 1,
            page_size: 15,
        }
        let self = this
        this.haulerApplicatorStore.refresh().then(() => {
            self.prepereHaulerTickets() // TOOD: possible fututre remove when optimize queryset on backend
            self.prepareLinkedOrders()
        })

        this.orderStore.params = {
            page: 1,
            status: "dispatcher_filters",
            haulers: "None",
            delivery: ["apply_haul", "haul"],
            ticket_status: "open",
        }
        this.orderStore.refresh()
    }

    searchHauler() {
        let self = this
        this.haulerApplicatorStore.params.page = null
        this.haulerApplicatorStore.refresh().then(() => {
            self.prepereHaulerTickets() // TOOD: possible fututre remove when optimize queryset on backend
            self.prepareLinkedOrders()
        })
        this.haulerApplicatorStore.params.page = 1
    }

    prepereHaulerTickets() {
        // Return only hauler_order tickets assign to picked Hauler.
        let self = this
        self.haulerApplicatorStore.list.forEach(hauler => {
            hauler.hauler_orders.forEach(order => {
                order.order.tickets = self.filterHaulerOrdersTickets(order.order.tickets, hauler.id)
            })
        })
    }

    filterHaulerOrdersTickets(tickets, hauler_id) {
        let filteredTickets = []
        tickets.forEach(ticket => {
            if (["mixed", "ready_to_bill", "pending"].includes(ticket.status)) {
                if (ticket.haulers.some(v => v.hauler == hauler_id)) {
                    filteredTickets.push(ticket)
                }
            }
        })
        return filteredTickets
    }

    loadMoreHaulers() {
        let self = this
        self.haulerApplicatorStore.loadMore().then(() => {
            self.prepereHaulerTickets()
            self.prepareLinkedOrders()
        })
    }

    prepareLinkedOrders() {
        // display linked items under oder without duplicates
        let self = this
        self.haulerApplicatorStore.list.forEach(haul => {
            let linkedOrders = []
            haul.hauler_orders.map(order => order.linked = false)
            haul.hauler_orders.forEach(order => {
                if (!linkedOrders.some(l => l.order.id == order.order.id)) {
                    linkedOrders.push(JSON.parse(JSON.stringify(order)))
                    // iterate through this hauler linked orders
                    let hauler_linked = order.linked_with.linked.filter(l => l.split("/")[0] != order.order.id && l.split("/")[1] == haul.id)
                    hauler_linked.forEach(linked_name => {
                        let order_id = linked_name.split("/")[0]
                        let linkedIndex = haul.hauler_orders.findIndex(o => o.order.id == order_id)
                        let linkedItem = haul.hauler_orders[linkedIndex]

                        linkedOrders[linkedOrders.length-1].linked = true
                        linkedOrders.push(JSON.parse(JSON.stringify(linkedItem)))
                    })
                }
            })
            haul.hauler_orders = linkedOrders
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/dispatch/ctrls.js